import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from '../../util/withRouter'
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Dropdown, DropdownButton, Tooltip, OverlayTrigger, Form } from 'react-bootstrap';
import { getDashboardFlags, filterDashboards, groupDashboards } from '../../util/dashboardUtils';
import { setSuccessMessage } from '../../modules/App/ErrorsActions';

import windowSize from '../../util/windowSize';

import FormattedMessage from '../FormattedMessage';
import Header from '../Header/Header';
import Confirm from '../Confirm/Confirm';
import ImageSize from '../ImageSize/ImageSize';
import Checkbox from '../Checkbox/Checkbox';
import IntegrationsDropdown from '../../modules/Integrations/components/IntegrationsDropdown';

import jiraCloudIcon from '../../assets/images/integrations/jira-cloud.svg';
import advancedKanbanIcon from '../../assets/images/integrations/advanced-kanban.svg';
import { INTEGRATIONS, getSwitchConnectionMessage, beautifyHost, prepareUrl, MANAGE_CONNECTIONS } from '../../util/integrations';

import { clearData as clearDataCFD } from '../../modules/CFD/CFDActions';

import {
  selectDashboard,
  saveSelected,
  updateModel,
  listAll,
  loadAkb,
  remove,
  downloadReport,
  applyView
} from './DashboardSelectorActions';
import { updateActivePanel } from '../Filter/FilterActions';
import { exportCsv } from '../../modules/Exporting/ExportingActions';
import { toggleNavigationShown } from '../../modules/App/AppActions';

import DashboardViews from '../DashboardView/DashboardViews';
import SaveDashboardView from '../DashboardView/SaveDashboardView';
import ProgressDashboard from '../ProgressDashboard/ProgressDashboard';

import { hasDashboardAccess, hasCreateDashboards } from '../../util/roles';
import { OBJECT_ID_REGEX, isDashboardWithoutId } from '../../util/pageRules';

import deleteIcon from '../../assets/img/delete.svg';

import createDashboardIcon from '../../assets/img/createDashboard-icon.svg';
import settingsIcon from '../../assets/img/settings-icon.svg';
import wallboardIcon from '../../assets/img/wallboard-icon.svg';
import saveIcon from '../../assets/images/save.svg';
import applyIcon from '../../assets/images/check-square-fill.svg';
import defaultBoardImg from '../../assets/images/board-default-icon.svg';
import personalBoardImg from '../../assets/images/board-person-icon.svg';
import editIcon from '../../assets/images/edit-blue.svg';
import cloudDownload from '../../assets/images/cloud-download-icon.svg';
import filterIcon from '../../assets/img/filter-icon.svg';
import dashboardIcon from '../../assets/img/dashboard.svg';
import akbIcon from '../../assets/images/universal-board-logo.svg';
import integrationsIcon from '../../assets/images/integrations/integrations.svg';
import unlinkIcon from '../../assets/img/unlink.svg';

const PLUGIN_PATH = process.env.RUN_ENV === 'production' ?
  '/plugins/servlet/ac/app.releasemanagement.agile-board' :
  '/plugins/servlet/ac/app.releasemanagement.agile-board.staging';

import '../Header/Header.scss';
import './DashboardSelector.scss';

function idDecode(str) {
  if (!str) {
    return {};
  }
  const jsonStr = Buffer.from(str, 'base64').toString();
  return JSON.parse(jsonStr);
}

export class DashboardSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: false,
      moreOpen: false,
      akbIsSet: false,
      akbFlag: false,
      akbShowChecked: true,
      q: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleUpdateClick = this.handleUpdateClick.bind(this);
    this.handleShowPanel = this.handleShowPanel.bind(this);
    this.handleCloseMore = this.handleCloseMore.bind(this);
    this.moreRef = React.createRef();
    this.handleAkbShowChecked = this.handleAkbShowChecked.bind(this);
  }

  componentDidMount() {
    if (!this.props.dashboards.length) {     
      this.props.listAll();
    } else if (
      !this.props.selected ||
      !this.props.selected._id ||
      _.findIndex(this.props.dashboards, { _id: this.props.selected._id }) === -1
    ) {
      this.selectDashboard();
    }        
    this.loadAkb();
    document.addEventListener('mousedown', this.handleCloseMore);
    document.addEventListener('keydown', this.handleCloseMore);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleCloseMore);
    document.removeEventListener('keydown', this.handleCloseMore);
    document.body.classList.remove('filter-shown');
  }

  handleCloseMore(event) {
    if (!this.state.moreOpen) return;
    if (event.type === 'keydown' && event.key !== 'Escape') return;
    if (event.type === 'mousedown' && (this.moreRef.current?.contains(event.target) || event.target.closest?.('.dropdown-menu'))) return;
    this.setState({ moreOpen: false });
  }

  redirectToCreate() {
    this.props.router.replace(`/create${this.props.location.search}`);
  }

  componentDidUpdate(prevProps) {
    if (this.props.noDashboards === true) {
      return this.redirectToCreate();
    }

    if (this.props.dashboards.length && !_.isEqual(prevProps.dashboards, this.props.dashboards)) {
      if (this.props.location.query.dashboardId) {
        const found = _.find(this.props.dashboards, {
          _id: this.props.location.query.dashboardId
        });
        !found && this.redirectToCreate();
      } else if (this.props.location.query.aid) {
        this.redirectToCreate();
      }
      this.selectDashboard();
    } else if (!this.props.dashboards.length) {
      this.props.select(undefined);
    }  

    if (!_.isEqual(prevProps.plugin, this.props.plugin)) {
      this.loadAkb();
    }
  }

  loadAkb() {
   if (
      this.props.plugin && 
      this.props.plugin.app === 'jira'
    ) {
      const showAkbConfirm = localStorage.getItem('show_akb_confirm');
      const akbIsSet = !!showAkbConfirm;
      const akbShowChecked = showAkbConfirm === 'true' || !akbIsSet;
      this.props.loadAkb();
      this.setState({ akbIsSet, akbShowChecked });
    }
  }

  open(url) {
    localStorage.setItem('show_akb_confirm', (!this.state.akbFlag).toString());
    this.setState({ akbIsSet: true, akbShowChecked: !this.state.akbFlag });

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('target', '_blank');
  
    link.setAttribute('style', 'visibility:hidden');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  selectDashboard() {
    if (!!this.props.wallmode) {
      return false;
    }

    let found;
    let selectedDashboard = this.props.dashboards[this.props.dashboards.length - 1];
    const selected = this.props.selected;

    if (selected && selected._id) {
      found = _.find(this.props.dashboards, b => b._id == selected._id);
      if (found) {
        selectedDashboard = found;
      }
    } else if (this.props.plugin.dashboardId) {
      found = _.find(this.props.dashboards, b => b._id == this.props.plugin.dashboardId);
      if (found) {
        selectedDashboard = found;
      }
    } else if (this.props.plugin.boardId) {
      found = _.find(this.props.dashboards, b => b.boardId == this.props.plugin.boardId);
      if (found) {
        selectedDashboard = found;
      }
    } else if (!!this.props.params.dashboardId && !!OBJECT_ID_REGEX.test(this.props.params.dashboardId)) {
      found = _.find(this.props.dashboards, b => b._id == this.props.params.dashboardId);
      if (found) {
        selectedDashboard = found;
      }
    } else {
      found = _.find(
        this.props.dashboards,
        b => this.props.user.config && b._id == this.props.user.config.selectedDashboard
      );
      if (found) {
        selectedDashboard = found;
      }
    }

    if (!found) {
      this.props.router.push(`/dashboard/${selectedDashboard._id}/process`);
    } else if (this.props.location.pathname === '/') {
      this.props.router.push(`/dashboard/${selectedDashboard._id}/process${this.props.router.location.search}`);
    } else if (isDashboardWithoutId(this.props.location.pathname)) {
      this.props.router.push(`/dashboard/${selectedDashboard._id}/${this.props.location.pathname}`);
    }

    if (this.props.location.query.view) {
      this.props.applyView(selectedDashboard._id, this.props.location.query.view);
    }

    this.props.select(selectedDashboard, this.props.location.query.view);
  }

  handleChange(dashboard) {
    const match = this.props.location.pathname.match(/\/dashboard\/.+\/(.+)/i);
    if (match && match.length == 2) {
      this.props.clearData(match[1]);
      this.props.router.push(`/dashboard/${dashboard._id}/${match[1]}`);
    } else {
      const to = this.props && this.props.location && this.props.location.search !== '' ?
        `/dashboard/${dashboard._id}/${this.props.location.search}` :
        `/dashboard/${dashboard._id}/process`;
      this.props.router.push(to);
    }
    this.props.select(dashboard);
    this.props.saveSelected(dashboard._id);

    if (this.props.onChange) {
      this.props.onChange();
    }
  }

  handleRedirect(url) {
    return window.location.replace(url);
  }

  handleUpdateClick(dashboard) {
    this.props.updateModel(dashboard);
    this.props.router.push('/update/' + dashboard._id);
  }

  handleExportClick = () => {
    this.props.exportCsv();
  };

  handleLogDownloadClick = dashboardId => {
    this.props.downloadReport(dashboardId);
  };

  closeNavigation() {
    if (this.props.windowWidth <= 992 && this.props.navigationShown) this.props.hideNavigation();
  }

  handleShowPanel(panel) {
    const filter = !(this.state.filter && this.props.activePanel === panel);
    if (filter) {
      this.props.updateActivePanel(panel);
      this.closeNavigation();
    }
    document.body.classList.toggle('filter-shown', filter);
    this.setState({ filter, moreOpen: false });
  }

  renderSmallScreenButtons(buttons) {
    const isPhone = this.props.windowWidth <= 600;
    const [create, ...rest] = buttons;
    const openPanel = this.state.filter ? this.props.activePanel : null;
    const hasInsights = !!(this.props.user && this.props.user.config && this.props.user.config.aiInsightsStatus);
    const insights = hasInsights && (
      <Button
        key="insights"
        size='sm'
        variant='secondary'
        className={openPanel === 'insights' ? 'btn-insights selected' : 'btn-insights'}
        aria-pressed={openPanel === 'insights'}
        onClick={() => this.handleShowPanel('insights')}
      >
        Insights
      </Button>
    );
    const filter = (
      <Button
        key="filter"
        id="filter-button"
        size='sm'
        variant='secondary'
        className={openPanel === 'filters' ? 'selected' : ''}
        aria-label="Filter"
        aria-pressed={openPanel === 'filters'}
        onClick={() => this.handleShowPanel('filters')}
      >
        <img src={filterIcon} alt="" />
      </Button>
    );
    const mcp = (
      <Link key="mcp" to="/mcp-docs" className='btn btn-sm btn-secondary btn-mcp-link' aria-label="MCP docs">MCP</Link>
    );
    const more = (
      <div key="more" ref={this.moreRef} className={`header-more ${this.state.moreOpen ? 'open' : ''}`}>
        <Button
          size='sm'
          variant='secondary'
          className='header-more-toggle'
          aria-label="More actions"
          aria-expanded={this.state.moreOpen}
          onClick={() => {
            if (!this.state.moreOpen) this.closeNavigation();
            this.setState(prevState => ({ moreOpen: !prevState.moreOpen }));
          }}
        >
          <span /><span /><span />
        </Button>
        <div className='header-more-items'>
          {isPhone ? [create, ...rest, insights, mcp] : rest}
        </div>
      </div>
    );

    return isPhone ? [filter, more] : [insights, filter, create, more].filter(Boolean);
  }

  handleAkbShowChecked(ev) {
    this.setState({ akbIsSet: false, akbFlag: !this.state.akbFlag, akbShowChecked: !this.state.akbFlag });
  }

  handleSearch = e => {
    this.setState({ q: e.target.value });
  };

  renderAkbButton(dashboard) {

    const akbConfig = this.getAkbConfig(dashboard);
    const { akbFlag } = this.state;
    const isAkb = dashboard.akbBoardId && dashboard.akbBoardId !== 'false';
    const showAkbButtonForDashboard = !isAkb; 

    const akbLabel = `Transform ${this.props.selected ? (this.props.selected.label || this.props.selected.name) : ''} to an Advanced Kanban Board`;

    const tooltip = (
      <Tooltip id="tooltip" className="tooltip_white">
        <span>{akbLabel}</span>
      </Tooltip>
    )

    const button = (
      <span className='img-dashboard'>
        <img src={akbIcon} alt="" />
      </span>
    )
    
    if (akbConfig.showAkbButton && akbConfig.showInstallAkb && showAkbButtonForDashboard) {
      return (
        <Link to="/akb" className='btn btn-icon btn-secondary btn-sm btn-akb' aria-label={akbLabel}>
          <OverlayTrigger placement="bottom" overlay={tooltip} delay={{ show: 250, hide: 2000 }}>
            {button}
          </OverlayTrigger>
        </Link>
      )
    }

    if (akbConfig.showAkbButton && !akbConfig.showInstallAkb && showAkbButtonForDashboard) {      
        return (
          <Confirm
            onConfirm={() => this.open(akbConfig.akbUrl)}
            body={
              <div>
                <p>
                  By clicking here, you'll be redirected to an external plugin offering advanced Kanban and Agile boards features.
                </p>
                <Checkbox
                  className='check_box_inline'
                  name="akbShow"
                  id="akbShow"
                  label="Don't ask me to create an Advanced Kanban Board anymore "
                  checked={akbFlag}
                  onChange={this.handleAkbShowChecked}
                />
              </div>
            }
            confirmClass="btn_orange_akb"
            confirmText="Proceed"
            icon={akbIcon}
            title="Explore Advanced Kanban & Agile Boards for Jira"
          >
            <Link className='btn_akb' aria-label={akbLabel}>
              <OverlayTrigger placement="bottom" overlay={tooltip} delay={{ show: 250, hide: 2000 }}>
                {button}
              </OverlayTrigger>
            </Link>
          </Confirm>
        )      
    }
  }

  getAkbConfig(dashboard) {
    const { plugin, akbLoaded, akb } = this.props;

    const isJiraPlugin = dashboard && plugin && plugin.app === 'jira';
    const isPartnerHost = isJiraPlugin;
    const isAkbInstalled = akbLoaded && akb && akb.installed;
    const showInstallAkb = dashboard && isJiraPlugin && isPartnerHost && akbLoaded && !isAkbInstalled;
    const showAkbButton = this.state.akbShowChecked && dashboard && isJiraPlugin && isPartnerHost && akbLoaded;
    
    const withHost = plugin && plugin.host;
    const akbBaseUrl = withHost && `${plugin.host}${PLUGIN_PATH}/boards`;
    let akbUrl = `${akbBaseUrl}?ac.action=import&ac.bid=${dashboard.decodedBoardId}&ac.nid=${dashboard._id}`;

    return {      
      showInstallAkb,
      showAkbButton,
      akbUrl
    };
  }

  renderMenuItem(dashboard, isSelected) {
    const failedJob = !this.props.isLoading && _.first(dashboard.failedJobs);
    const hasFailedJob = !!failedJob && !!failedJob.type;

    const isAkb = dashboard.akbBoardId && dashboard.akbBoardId !== 'false';

    return (
      <React.Fragment>
        {isSelected && this.renderAkbButton(dashboard)}
        {dashboard.organization && !dashboard.organization.logo ? (
          isAkb ?
          (<span className='btn img-dashboard'>
            <img src={akbIcon} alt="default-board" />
          </span>) : 
          (<span className='btn img-dashboard'>
            <img src={defaultBoardImg} alt="default-board" />
          </span>)
        ) : !dashboard.organization ? (
          isAkb ? 
          (<span className='btn img-dashboard'>
            <img src={akbIcon} alt="default-board" />
          </span>) : 
          (<span className='btn img-dashboard'>
            <img src={personalBoardImg} alt="personal-board" />
          </span>)
        ) : (
          <span className='btn img-dashboard'>
            <img
              src={dashboard.organization.logo}
              alt="org-logo"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = defaultBoardImg;
              }}
            />
          </span>
        )}
        <div className='dropdown-text'>
          <p>{dashboard.label || dashboard.name} </p>

          {hasFailedJob && <span className='sync-failed'>Needs attention</span>}
          {!hasFailedJob && !!dashboard.createdBy && !dashboard.updatedBy  && dashboard.createdBy !== 'no_user' && (
            <span>Created by: {dashboard.createdBy}</span>
          )}
          {!hasFailedJob && !!dashboard.updatedBy && dashboard.updatedBy !== 'no_user' && (
            <span>Updated by: {dashboard.updatedBy}</span>
          )}
           {!hasFailedJob && (dashboard.updatedBy === null && dashboard.createdBy === 'no_user' || dashboard.updatedBy === 'no_user') && (
            <span className='sync-fail-soon'>Needs attention</span>
          )}
        </div>
        {!isSelected && dashboard.sampleDataSourceId && (
          <div className='sample-badge'>Sample data</div>
        )}
      </React.Fragment>
    );
  }

  renderProgressDashboard(user) {
    if (user && user.allowedDashboards) {
      return <ProgressDashboard limitNumber={user.allowedDashboards} usedNumber={user.dashboards}/>
    }
  }

  renderEditButton() {
    const { user, app, selected } = this.props;

    const switchMessage = user && selected && app && getSwitchConnectionMessage(selected, app, user);
    const connection = user && selected && _.find(user.integrations, c => c.accountId === selected.accountId);

    const switchUrl = selected && prepareUrl(
      selected.application,
      'api/tenant/integration/switch',
       { accountId: selected.accountId, from: '/update/' + selected._id}
    );

    const connectUrl = selected && connection && prepareUrl(
      INTEGRATIONS[connection.id].app,
      INTEGRATIONS[connection.id].connect,
      {
        ...INTEGRATIONS[connection.id].params,
        h: connection.host && !INTEGRATIONS[connection.id].params.cloud ? beautifyHost(connection.host) : undefined,
        connect: true,
        account: connection.accountId,
        user: user._id,
        path: '/update/' + selected._id,
        from: app
      }
    );
    
    if (switchMessage === true || !switchMessage) {
      return (
        <li onClick={ev => switchMessage === true ? this.handleRedirect(switchUrl) : this.handleUpdateClick(selected)}>
          <div className='btn'>
            <span className="title"><img src={editIcon} alt="#"/> Edit dashboard</span>
            <span className="help-text">
              Map process states, manage custom fields and update your dashboard data.
            </span>
          </div>
        </li>
      )
    } else {
      return (
        <li onClick={ev => this.handleRedirect(connectUrl)}>
          <div className='btn'>
            <span className="title"><img src={unlinkIcon} alt="#"/> Link connection to edit dashboard</span>
              <span className="help-text">
              {`Connection to ${_.upperFirst(selected.application)} is missing.`} Link the connection to edit this dashboard.
            </span>
          </div>
        </li>
      )
    }
  }

  render() {
    const { wallmode, outside, user, app, plugin, selected, dashboards } = this.props;
    let buttons = [];
    const isJiraTopPlugin = plugin && plugin.app === 'jira' && plugin.noProject;
    const mainView = !outside || (outside && outside.app === 'jira' && outside.noBoard) || isJiraTopPlugin;
    
    const projectId = this.props.plugin.projectId;
    if (!wallmode) {
      if (mainView) {
        buttons = [
          hasCreateDashboards(this.props.user) && (
            <DropdownButton
              key="1"
              id="createdashboards-dropdown"
              variant='secondary'
              size='sm'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-createdashboards" className='tooltip_dark'>Create dashboard</Tooltip>}>
                  <img src={createDashboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link key="1" to="/create" className='btn'>
                  <span className="title"><img src={createDashboardIcon} alt="#"/> Create dashboard</span>
                  <span className="help-text">
                    Select <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" determiner /> and arrange
                    your <FormattedMessage id={`${app}.list`} plural="true" /> to define your workflow and create a team dashboard.
                  </span>
                </Link>
              </li>             
              {!!user.allowedDashboards && (
                <li className="menu-footer">{this.renderProgressDashboard(user)}</li>
              )}
            </DropdownButton>
          ),

          this.props.selected && (
            <DropdownButton
              key="2"
              id="dashboards-dropdown"
              size='sm'
              variant='secondary'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-settings" className='tooltip_dark'>Dashboard settings</Tooltip>}>
                  <img src={settingsIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li onClick={ev => this.handleExportClick()}>
                <div className='btn'>
                  <span className="title"><img src={cloudDownload} alt="#"/> Export dashboard data</span>
                  <span className="help-text">Export your dashboard data as a CSV file to create custom reports.</span>
                </div>
              </li>
              {hasDashboardAccess(user, selected._id, 'edit') && this.renderEditButton()}
              {hasDashboardAccess(this.props.user, this.props.selected._id, 'delete') && (
                <li>
                  <Confirm
                    onConfirm={ev => this.props.remove(this.props.selected._id)}
                    body={
                      <p>
                        Are you sure you want to delete <strong>{this.props.selected.label || this.props.selected.name}</strong>?
                      </p>
                    }
                    confirmText="Delete"
                    icon={deleteIcon}
                    title="Delete dashboard" >
                    <div className='btn'>
                      <span className="title red"><img src={deleteIcon} alt="#"/> Delete dashboard</span>
                      <span className="help-text">
                        Delete this dashboard and all data synced with it. This action cannot be undone.
                      </span>
                    </div>
                  </Confirm>
                </li>
              )}
              {user.remote &&
                this.props.selected.config &&
                this.props.selected.config.logCards &&
                hasDashboardAccess(this.props.user, this.props.selected._id, 'edit') && (
                  <li onClick={ev => this.handleLogDownloadClick(this.props.selected._id)}>
                    <div className='btn'>
                      Download log
                      <span className="help-text">Download the dashboard log for troubleshooting.</span>
                    </div>
                  </li>
                )}
              {hasDashboardAccess(this.props.user, this.props.selected._id, 'delete') && !!user.allowedDashboards && (
                <li className="menu-footer">{this.renderProgressDashboard(user)}</li>
              )}
            </DropdownButton>
          ),

          this.props.selected && (
            <DropdownButton
              key="3"
              id="dashboards-dropdown"
              size='sm'
              variant='secondary'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-wallboard" className='tooltip_dark'>Manage wallboards</Tooltip>}>
                  <img src={wallboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link to={`/settings/${this.props.selected._id}`} className='btn'>
                  <span className="title"><img src={wallboardIcon} alt="" /> Manage wallboards</span>
                  <span className="help-text">
                    Automatically rotate your dashboard charts on a big screen for presentations, meetings or
                    team updates. Wallboard links are public and can be viewed without logging in.
                  </span>
                </Link>
              </li>
            </DropdownButton>
          )
        ];
      } else {
        buttons = [
           projectId && hasCreateDashboards(this.props.user) && (
            <DropdownButton
              key="1"
              id="createdashboards-dropdown"
              variant='secondary'
              size='sm'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-createdashboards" className='tooltip_dark'>Create dashboard</Tooltip>}>
                  <img src={createDashboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link key="1" to="/create" className='btn'>
                  <span className="title"><img src={createDashboardIcon} alt="#"/> Create dashboard</span>
                  <span className="help-text">
                    Select <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" determiner /> and arrange
                    your <FormattedMessage id={`${app}.list`} plural="true" /> to define your workflow and create a team dashboard.
                  </span>
                </Link>
              </li>             
              {!!user.allowedDashboards && (
                <li className="menu-footer">{this.renderProgressDashboard(user)}</li>
              )}
            </DropdownButton>
          ),         
          this.props.selected && (<DropdownButton
            key="2"
            id="dashboards-dropdown"
            size='sm'
            variant='secondary'
            title={
              <OverlayTrigger placement="bottom"
                overlay={<Tooltip id="tooltip-settings" className='tooltip_dark'>Dashboard settings</Tooltip>}>
                <img src={settingsIcon} alt="" />
              </OverlayTrigger>
            }
          >
            <li>
              <Button onClick={ev => this.handleExportClick()}>
              <span className="title"><img src={cloudDownload} alt="#"/> Export dashboard data</span>
                <span className="help-text">Export your dashboard data as a CSV file to create custom reports.</span>
              </Button>
            </li>
            {hasDashboardAccess(this.props.user, this.props.selected._id, 'edit') && (
              <li>
                <Button onClick={ev => this.handleUpdateClick(this.props.selected)}>
                  <span className="title"><img src={editIcon} alt="#"/> Edit dashboard</span>
                  <span className="help-text">
                    Map process states, manage custom fields and update your dashboard data.
                  </span>
                </Button>
              </li>
            )}
            {hasDashboardAccess(this.props.user, this.props.selected._id, 'delete') && (
                <li>
                  <Confirm
                    onConfirm={ev => this.props.remove(this.props.selected._id)}
                    body={
                      <p>
                        Are you sure you want to delete <strong>{this.props.selected.label || this.props.selected.name}</strong>?
                      </p>
                    }
                    confirmText="Delete"
                    icon={deleteIcon}
                    title="Delete dashboard" >
                    <div className='btn'>
                      <span className="title red"><img src={deleteIcon} alt="#"/> Delete dashboard</span>
                      <span className="help-text">
                        Delete this dashboard and all data synced with it. This action cannot be undone.
                      </span>
                    </div>
                  </Confirm>
                </li>
              )}
            {user.remote &&
              this.props.selected.config &&
              this.props.selected.config.logCards &&
              hasDashboardAccess(this.props.user, this.props.selected._id, 'edit') && (
                <li>
                  <Button onClick={ev => this.handleLogDownloadClick(this.props.selected._id)}>
                    Download log
                    <span className="help-text">Download the dashboard log for troubleshooting.</span>
                  </Button>
                </li>
              )}
          </DropdownButton>),
          this.props.selected && (
            <DropdownButton
              key="3"
              id="dashboards-dropdown"
              size='sm'
              variant='secondary'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-wallboard" className='tooltip_dark'>Manage wallboards</Tooltip>}>
                  <img src={wallboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link to={`/settings/${this.props.selected._id}`} className='btn'>
                  <span className="title"><img src={wallboardIcon} alt="" /> Manage wallboards</span>
                  <span className="help-text">
                    Automatically rotate your dashboard charts on a big screen for presentations, meetings or
                    team updates. Wallboard links are public and can be viewed without logging in.
                  </span>
                </Link>
              </li>
            </DropdownButton>
          )
        ];
      }
    }

    if (this.props.selected && !wallmode) {
      buttons.push(
        <DropdownButton
          key="4"
          id="filter-dropdown"
          size='sm'
          variant='secondary'
          title={
            <OverlayTrigger placement="bottom"
                overlay={<Tooltip id="tooltip-dashboard" className='tooltip_dark'>Dashboard views</Tooltip>}>
              <img src={dashboardIcon} alt="" />
            </OverlayTrigger>
          }>
          <li>
            <DashboardViews>
              <div className='btn'>
                <span className="title"><img src={applyIcon} alt="#" /> Apply dashboard view</span>
                <span className="help-text">
                  Apply a previously saved set of controls and filters to this dashboard.
                </span>
              </div>
            </DashboardViews>
          </li>
          <li>
            <SaveDashboardView>
              <div className='btn'>
                <span className="title"><img src={saveIcon} alt="#" /> Save current dashboard view</span>
                <span className="help-text">Save the current controls and filters as a dashboard view.</span>
              </div>
            </SaveDashboardView>
          </li>
        </DropdownButton>
      );
    }

    if (this.props.windowWidth <= 992 && !wallmode) {
      buttons = this.renderSmallScreenButtons(buttons);
    }

    const {
      hasAkbBoards,
      hasNormalBoards,      
      showDropDown
    } = getDashboardFlags(dashboards, outside, plugin, wallmode);

    const filteredNormalBoards = filterDashboards(
      dashboards,
      this.state.q,
      'normal'
    );

    const filteredAkbBoards = filterDashboards(
      dashboards,
      this.state.q,
      'advanced'
    );

    const hasIntegrationsSelection = user && user.hasTenant && !outside;
    const groupedBoards = hasIntegrationsSelection && groupDashboards(dashboards, user.integrations, this.state.q);

    return (
      <Header showReport={true} 
        showSync
        dashboardSelector={
          <React.Fragment>
            {showDropDown ? (
              <DropdownButton
                className="dropdown-dashboard-list"
                onToggle={show => show && this.closeNavigation()}
                title={this.props.selected && this.props.selected._id ? this.renderMenuItem(this.props.selected, true) : ''}
                id="dashboards-dropdown"
                variant='secondary'
              >
                
                <Form.Group controlId="q" className='search-wrap'>
                  <Form.Control 
                    type="text" 
                    name="q"  
                    value={this.state.q} 
                    onChange={this.handleSearch} 
                    placeholder='Search dashboard' />
                </Form.Group>
                <div className='dropdown-scroll'>
                  {groupedBoards &&
                    _.map(groupedBoards, (boards, group) => {
                      const isSingleGroup = _.keys(groupedBoards).length === 1;
                      return (
                        <div className='dashboard-group' key={group}>
                          {!isSingleGroup && 
                            <div className="subtitle">
                              <img src={INTEGRATIONS[group].icon} alt=""/> 
                              {`${INTEGRATIONS[group].boardsName}`}
                            </div>
                          }
                          {boards.map((dashboard, i) => (
                            <Dropdown.Item
                              key={i}
                              className={this.props.selected && this.props.selected._id == dashboard._id ? 'active' : ''}
                              eventKey={i}
                              onClick={() => this.handleChange(dashboard)}
                            >
                              {this.renderMenuItem(dashboard, false)}
                            </Dropdown.Item>
                          ))}
                        </div>
                      );
                    })
                  }
                  <div className='dashboard-group'>
                    {!groupedBoards && hasNormalBoards && hasAkbBoards && <div className="subtitle"><img src={jiraCloudIcon} alt=""/> Jira boards</div>}
                    {!groupedBoards && hasNormalBoards && filteredNormalBoards
                      .map((dashboard, i) => {
                        return (
                          <Dropdown.Item
                            key={i}
                            className={this.props.selected && this.props.selected._id == dashboard._id ? 'active' : ''}
                            eventKey={i}
                            onClick={() => this.handleChange(dashboard)}
                          >
                            {this.renderMenuItem(dashboard, false)}
                          </Dropdown.Item>
                        );
                      })
                    }
                  </div>
                  <div className='dashboard-group'>
                    {!groupedBoards && hasAkbBoards && <div className="subtitle"><img src={advancedKanbanIcon} alt=""/> Advanced Kanban & Agile Boards</div>}
                    {!groupedBoards && hasAkbBoards && filteredAkbBoards
                        .map((dashboard, i) => {
                          return (
                            <Dropdown.Item
                              key={i} 
                              className={this.props.selected && this.props.selected._id == dashboard._id ? 'active' : ''}
                              eventKey={i}
                              onClick={() => this.handleChange(dashboard)}
                              >
                              {this.renderMenuItem(dashboard)}
                            </Dropdown.Item>
                          );
                        }
                      )
                    }
                  </div>
                </div>
                {hasIntegrationsSelection && (
                  <IntegrationsDropdown title={MANAGE_CONNECTIONS}>
                    <div className="connections_button"><img src={integrationsIcon}/>{MANAGE_CONNECTIONS}</div>
                  </IntegrationsDropdown>
                )}
              </DropdownButton>
            ) : (
              <div className="title-dashboard">
                {!this.props.dataIsLoading && (
                  <div className='title-power-up'>
                    {this.props.selected && this.props.selected._id ? this.renderMenuItem(this.props.selected) : ''}
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        }
        buttons={buttons}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    listAll: () => dispatch(listAll()),
    loadAkb: () => dispatch(loadAkb()),    
    updateModel: dashboard => dispatch(updateModel(dashboard)),
    select: (dashboardId, viewId) => dispatch(selectDashboard(dashboardId, viewId)),
    saveSelected: dashboardId => dispatch(saveSelected(dashboardId)),
    remove: id => dispatch(remove(id)),
    exportCsv: () => dispatch(exportCsv()),
    downloadReport: id => dispatch(downloadReport(id)),
    applyView: (dashboardId, viewId) => dispatch(applyView(dashboardId, viewId)),
    updateActivePanel: panel => dispatch(updateActivePanel(panel)),
    hideNavigation: () => dispatch(toggleNavigationShown(false)),
    switchConnection: msg => dispatch(setSuccessMessage(msg, { toastId: 'switch_connection' })),
    clearData: chart => {
      switch (chart) {
        case 'cfd':
          return dispatch(clearDataCFD());
      }
    }
  };
};

const mapStateToProps = state => {
  return {
    dataIsLoading: state.app.isLoading,
    activePanel: state.filters.activePanel,
    navigationShown: state.app.navigationShown,
    app: state.app.app,
    wallmode: state.app.wallmode,
    outside: state.app.outside,
    plugin: state.app.plugin,
    user: state.auth.user,
    akb: state.dashboards.akb,
    akbLoaded: state.dashboards.akbLoaded,
    dashboards: state.dashboards.list,
    boards: state.dashboards.boards,
    isLoading: state.dashboards.isLoading,
    selected: state.dashboards.selected,
    noDashboards: state.dashboards.noDashboards
  };
};

export default windowSize(withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardSelector)));
